export const en = {
  translation: {
    nav: {
      title: 'Zen Life Acupuncture',
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      gallery: 'Gallery',
      appointment: 'Appointment',
      store: 'Store',
      herbtea: 'Herbal Tea',
      telemedicine: "Telemedicine",
    },
    home: {
      welcome: 'Welcome to Zen Life Acupuncture',
      "subtitle": "Heritage and Innovation, Healing with Care",
      "description1": "Experience the unique healing power of acupuncture through the perfect blend of modern medicine and traditional Chinese medicine.",
      "description2": "We carry the wisdom of three generations, integrating modern medical principles to provide each patient with professional, personalized care.",
      "description3": "Our team of acupuncturists is not only skilled in traditional acupuncture, cupping, gua sha, and herbal medicine, but has also developed proprietary acupuncture techniques that have successfully treated complex conditions such as facial paralysis, herniated discs, sciatica, and cervical nerve compression pain.",
      "description4": "Here, you’ll find the depth of traditional Chinese medicine alongside the effectiveness of modern medical insights. Let us help you restore health and vitality!",

      subtitleinsurance: 'Wondering if your insurance covers acupuncture? ',
      insuranceprompt: 'Text your question to 408-922-6848 or email zenlifeacu@gmail.com. Please include your name, phone number, date of birth, and photos of both sides of your insurance card.',
      bookButton: 'Make an Appointment',
      contactButton: 'Contact Us',
      promotions: 'Promotions and Announcements',
      videoTitle: "Mystery Herbal Tea Blind Box",
      videoDescription: "Every Sunday, we offer a free special hidden Chinese herbal tea drink, available only for same-day tasting"
    },
    services: {
      title: 'Our Services',
      acupuncture: {
        title: 'Acupuncture',
        description: 'Treatment for shoulder pain, headache, sciatica pain, allergies, wrinkle reduction, weight loss, insomnia, and more.',
      },
      electroacupuncture: {
        title: 'Electroacupuncture',
        description: 'Chronic pain, Neurological disorders, Sports injury recovery, Emotional issues, Digestive issues ,Gynecological issues'
      },
      cupping: {
        title: 'Cupping',
        description: 'Pain relief, dampness drainage, sciatica pain treatment, detoxification, and more.'
      },
      guaSha: {
        title: 'Gua Sha',
        description: 'Treatment for menstrual pain, lower back pain, knee pain, and immune system improvement.'
      },
      manualTherapy: {
        title: 'Manual Therapy',
        description: 'Hands-on therapeutic techniques to relieve pain and promote healing.'
      },
      infraLight: {
        title: 'Infra Light Therapy',
        description: 'Advanced light therapy for enhanced healing and pain relief.'
      },
      herbs: {
        title: 'Chinese Herbs',
        description: 'Traditional herbal remedies customized to your specific needs.'
      }
    },
    contact: {
      title: 'Contact Us',
      direction: 'Direction',
      address: {
        title: 'Address',
        value: '8 N Abel St, Milpitas, CA 95035'
      },
      phone: {
        title: 'Phone or Text',
        regularHours: 'Regular Hours: 408-922-6848',
        afterHours: 'After Hours: 408-465-4289'
      },
      email: {
        title: 'Email',
        value: 'zenlifeacu@gmail.com'
      },
      payment: {
        title: 'Payment Methods',
        description: 'We accept all major PPO insurance, Credit Cards, HSA, PayPal, Venmo'
      },
      findUs: 'We are located in the heart of Milpitas, easily accessible from both I-880 and I-680.',
      specializedClaims: "Specialized Insurance Claims",
      carAccidentClaims: "We accept car accident insurance claims and provide comprehensive treatment documentation for patients, insurance companies, and legal representatives handling claims.",
      workersCompClaims: "We process workers' compensation claims for workplace injuries, helping patients recover and return to work.",
      legalReferrals: "We welcome patient referrals from law firms specializing in personal injury and workers' compensation cases."
    },

    footer: {
      title: 'Zen Life Acupuncture',
      address: '8 N Abel St\nMilpitas, CA 95035',
      contact: {
        title: 'Contact',
        phone: 'Phone: 408-922-6848',
        email: 'Email: zenlifeacu@gmail.com'
      },
      social: {
        title: 'Connect With Us',
        wechat: 'WeChat: ZenLifeAcupuncture',
        rednote: 'RedNote: ZenLifeAcu'
      },
      copyright: 'Zen Life Acupuncture. All rights reserved.',
     
    },
    telemedicine: {
      title: "Telemedicine Services",
      subtitle: "Virtual consultations with our experienced acupuncturists from the comfort of your home",
      benefitsTitle: "Benefits of Our Telemedicine Service",
      payWithPayPal: "Pay with PayPal", // English
      // payWithPayPal: "Pagar con PayPal", // Spanish
      // payWithPayPal: "PayPalで支払う", // Japanese
      // payWithPayPal: "Thanh toán bằng PayPal", // Vietnamese
      // payWithPayPal: "使用PayPal付款", // Chinese
      benefits: {
        benefit1: "Convenient access to professional Chinese medicine consultation without leaving home",
        benefit2: "Personalized herbal prescriptions based on your specific health needs",
        benefit3: "Detailed health assessment and customized treatment plans",
        benefit4: "Follow-up care and adjustments to your treatment as needed",
        benefit5: "Save time and avoid travel while receiving expert care",
        benefit6: "Access to our extensive knowledge of traditional Chinese medicine and herbal remedies"
      },
      processTitle: "How Our Telemedicine Service Works",
      process: {
        step1: {
          title: "1. Make Payment",
          description: "Use the PayPal button below to make payment for your 30-minute telemedicine consultation."
        },
        step2: {
          title: "2. Schedule Your Appointment",
          description: "After payment, schedule your appointment online using your order number. You'll be able to upload your medical history and any relevant lab results."
        },
        step3: {
          title: "3. Virtual Consultation",
          description: "Meet with our licensed acupuncturist via Zoom to discuss your medical condition. We'll provide a comprehensive assessment, herbal prescription if needed, and health advice."
        },
        step4: {
          title: "4. Herbal Medicine Payment (if needed)",
          description: "If herbal medicine is recommended, we'll send you an invoice for the herbs and shipping costs. Payment can be made online."
        },
        step5: {
          title: "5. Receive Your Herbs",
          description: "We'll prepare and ship your custom herbal formula directly to your home."
        }
      },
      paymentTitle: "Book Your Telemedicine Consultation",
      consultationFee: "30-Minute Consultation: $50",
      afterPayment: "After payment, you'll receive a confirmation email with your order number. Use this number to schedule your appointment.",
      scheduleButton: "Schedule Appointment",
      herbsTitle: "About Our Herbal Medicines",
      herbsDescription: "Our herbal prescriptions are customized to your specific health needs. We use only high-quality, authentic Chinese herbs that are tested for purity and potency.",
      shippingInfo: "Herbal medicine costs and shipping fees vary depending on the prescription and your location. We offer various shipping methods to meet your needs and budget."
    },
    store: {
      title: "Zen Life Online Store",
      subtitle: "Traditional Chinese Medicine Products",
      description: "Browse our selection of high-quality traditional Chinese medicine products. We ship nationwide.",
      buyNow: "Buy Now",
      products: [
        {
          name: "100% Natural Hydra Anti-Itch Cream",
          price: "$39.99",
          description: "Relieve itching and dry, flaky skin caused by eczema or atopic dermatitis. For external use only",
          image: "/images/products/product1.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/USDMG75T3T7CW"
        },
        {
          name: "Assorted Herbal Teas for Health Conditioning",
          price: "$80",
          description: "Handcrafted herbal blends specifically formulated for various health conditions. Each premium pack provides a full day's supply of therapeutic tea, adding up to 1 gallon of water for maximum benefit. Our carefully selected herbs deliver natural wellness support throughout your day. ",
          image: "/images/products/product2.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
        }
        // More products can be added here later
      ]
    },
  
    herbtea: {
      title: "🌿 Chinese Herbal Tea · Specially Crafted for Bay Area Engineers 🌿",
      subtitle: "☕ Wellness Even in Busy Times — We Care for Your Physical and Mental Health!",
      description: "Based on pure natural Chinese herbs and traditional Chinese medicine theory, we carefully formulate various wellness teas suitable for Bay Area engineers. According to different body constitutions and needs, you can flexibly choose the tea therapy course that suits you:",
      benefits: [
        "✔ Scientifically proportioned dosage, no need to brew medicine",
        "✔ Tea bags for instant brewing, simple and convenient",
        "✔ One course lasts three weeks, just three cups per week",
        "✔ Welcome to our store for a free tasting!"
      ],
      benefits1: "Benefits",
      ingredients: "Ingredients",
      customService: {
        title: "🧑‍⚕️ Personalized Custom Service · Tailored to Your Body",
        description: "We provide one-on-one TCM constitution analysis and custom tea services to create a personalized wellness plan for you:",
        options: [
          {
            name: "Health-Maintenance Personalized Tea",
            details: "Consultation + One course of wellness tea",
            price: "Only $80"
          },
          {
            name: "Therapeutic Chinese Medicine Service",
            details: "Consultation + One course of concentrated Chinese medicine decoction (for specific symptom treatment)",
            price: "$200"
          }
        ]
      },
      popularTeas: {
        title: "🍵 Five Popular Wellness Teas Recommended",
        teas: [
          {
            id: 1,
            name: "Honeysuckle Tea",
            ingredients: "Astragalus, Honeysuckle, Magnolia Flower, Chrysanthemum",
            benefits: "Enhances immunity, relieves nasal sensitivity and pollen allergies"
          },
          {
            id: 2,
            name: "Heart-Nourishing Calming Drink",
            ingredients: "Salvia, Lily Bulb, Sour Jujube Seed, Acorus Calamus",
            benefits: "Improves sleep quality, calms the mind"
          },
          {
            id: 3,
            name: "Ginseng Poria Atractylodes Drink",
            ingredients: "Tangerine Peel, Atractylodes, Poria, Coix Seed, Jinqiancao, Buddha's Hand",
            benefits: "Strengthens the spleen, removes dampness, regulates the digestive system"
          },
          {
            id: 4,
            name: "Mind-Calming Intelligence-Enhancing Tea",
            ingredients: "Alpinia Oxyphylla, Goji Berries, Salvia, Acorus Calamus",
            benefits: "Improves cerebral circulation, refreshes the mind"
          },
          {
            id: 5,
            name: "Beauty Nourishing Tea",
            ingredients: "Astragalus, Salvia, Angelica, Goji Berries, Rose Flower",
            benefits: "Replenishes qi and blood, beautifies skin"
          }
        ]
      },
      pricing: {
        title: "💰 Price Benefits · Flexible Options",
        options: [
          "Three-cup trial pack: $15",
          "Six-cup basic pack: $26",
          "Nine-cup course pack: $40",
          "Health-maintenance custom (consultation + tea): $80",
          "Therapeutic concentrated Chinese medicine (consultation + decoction): $200"
        ],
        promotion: "🎁 Visit our store for a free tasting and start your personalized wellness journey!"
      }
    }

  },
  electroAcupunture: {
    "header": "Electro-Acupuncture and Its Benefits",
    "section1_title": "Basic Concept of Electro-Acupuncture",
    "section1_text": "Electro-acupuncture is a treatment method that combines traditional acupuncture with modern electrotherapy. It stimulates specific points on the body using mild electrical currents. It is widely used for pain management, neurological disorders, musculoskeletal issues, and overall health improvement.",

    "section2_title": "Main Benefits of Electro-Acupuncture",
    "benefit1": "Pain Relief: Electro-acupuncture helps alleviate chronic and acute pain by regulating pain signals in the nervous system, used for conditions like arthritis, headaches, shoulder pain, etc.",
    "benefit2": "Improves Circulation: The electrical stimulation promotes local blood circulation, helps deliver oxygen and nutrients to tissues, and reduces inflammation.",
    "benefit3": "Regulates the Nervous System: Electro-acupuncture stimulates the autonomic nervous system, helping with anxiety, insomnia, and boosting immune response.",
    "benefit4": "Relieves Muscle Spasms and Relaxation: It effectively relaxes tense muscles, improving muscle flexibility and alleviating cramps and stiffness.",
    "benefit5": "Promotes Tissue Repair and Recovery: Electro-acupuncture accelerates tissue repair, helps cell regeneration, commonly used for rehabilitation after injuries.",
    "benefit6": "Enhances Immunity: It regulates immune responses, improving the body's resistance to infections, and is beneficial for chronic and autoimmune conditions.",

    "section3_title": "Indications for Electro-Acupuncture",
    "indication1": "Chronic pain (such as arthritis, back pain, neck pain)",
    "indication2": "Neurological disorders (such as stroke rehabilitation, facial paralysis)",
    "indication3": "Sports injury recovery (muscle strain, ligament damage)",
    "indication4": "Emotional issues (such as insomnia, anxiety)",
    "indication5": "Digestive issues (constipation, diarrhea)",
    "indication6": "Gynecological issues (irregular periods, dysmenorrhea)",

    "section4_title": "Precautions for Electro-Acupuncture",
    "precaution1": "Consultation before treatment: Electro-acupuncture is not suitable for everyone, especially those with heart disease, skin conditions, or pregnant women. Consult a professional acupuncturist before use.",
    "precaution2": "During treatment, you may feel mild tingling or electrical sensations. If discomfort occurs, inform the doctor to adjust the intensity of the current.",
    "precaution3": "Avoid overuse: While electro-acupuncture is effective, frequent or excessive use may cause negative effects on the skin and tissues."
  }

};